import { cn } from "@/lib/utils.js";

/**
 * Page top bar matching product mockups: icon + title/subtitle left, actions right.
 * @param {Object} props
 * @param {import("lucide-react").LucideIcon} [props.icon] - Leading icon
 * @param {string} props.title - Page title
 * @param {string} [props.subtitle] - Supporting line under the title
 * @param {React.ReactNode} [props.children] - Right-side actions (e.g. PageHeaderActions)
 * @param {string} [props.className] - Extra classes on the header element
 * @returns {JSX.Element}
 */
export default function PageHeader({
  icon: Icon,
  title,
  subtitle,
  children,
  className,
}) {
  return (
    <header
      className={cn(
        "flex-shrink-0 bg-card border-b border-border px-4 sm:px-6 py-4",
        className
      )}>
      <div className='flex items-center justify-between gap-4'>
        <div className='flex items-center gap-3 min-w-0'>
          {Icon ? (
            <Icon
              className='shrink-0 text-muted-foreground'
              size={22}
              aria-hidden='true'
            />
          ) : null}
          <div className='min-w-0'>
            <h2 className='text-xl sm:text-2xl font-semibold text-foreground leading-tight'>
              {title}
            </h2>
            {subtitle ? (
              <p className='text-sm text-muted-foreground mt-0.5'>{subtitle}</p>
            ) : null}
          </div>
        </div>
        {children ? (
          <div className='shrink-0 flex flex-wrap items-center justify-end gap-3'>
            {children}
          </div>
        ) : null}
      </div>
    </header>
  );
}
